import {Component, element as $, services} from '@contorion/core';
import { IPopupService} from "../../popup/interfaces/popup-service.interface";

const CLOSE_SPONSORED_MODAL: string = '.js-sponsored-label-modal-close';

export class SponsoredLabelComponent extends Component {

    protected get closeButton(): HTMLElement {
        return <HTMLElement> $(CLOSE_SPONSORED_MODAL);
    }
    constructor(element: HTMLButtonElement) {
        super(element);

        this.init();
    }

    protected popupService: IPopupService;

    protected async init() {
        this.popupService = await services.get('popup');
        this.popupService.removeFromDom(true);
        this.element.addEventListener('click', this.handleClickEvent.bind(this));
        this.closeButton.addEventListener('click', this.onCloseModal.bind(this));
    }

    protected handleClickEvent() {
        this.popupService.showPopup()
    }

    protected onCloseModal() {
        this.popupService.closePopup()
    }
}
